// extracted by mini-css-extract-plugin
export default {"dark-mode":"CreateNotes_dark-mode__RZJn9","header":"CreateNotes_header__a-Vzr"};